<div [ngClass]="buttonClass">
    <a (click)="onClickParent()" tabindex="0">
        @if(options.text) {
        <span>{{options.text}}</span>
        }
        @if(options.imageClass) {
        <i class="{{options.imageClass}}"></i>
        }
        @if(options.items) {
        <i class="fa-solid fa-angle-down"></i>
        }
    </a>
    @if(options.items) {
    <div [ngClass]="dropdownClass" [class.open]="displayChild" [style.margin-left]="options.leftMargin">
        <ul>
            @for(o of options.items; track o) {
            <li [class.separator]="o.type == DropdownType.Separator" [class.disabled]="o.disabled">
                <a (click)="onClick(o)" tabindex="0">
                    <span>
                        @if(o.type == DropdownType.ImageAndText) {
                        <i class="{{o.imageClass}}"></i>
                        }
                    </span>
                    <span [innerHTML]="o.text"></span>
                </a>
            </li>
            }
        </ul>
    </div>
    }
</div>
<div class="backdrop" [class.open]="displayChild" (click)="closeMenu()"></div>